/* Zareen Jewels — Footer: link columns are accordions on phones, always open on desktop */
(() => {
  const mq = window.matchMedia('(min-width: 750px)');
  const init = (root) => {
    if (!root || root.dataset.zjfReady) return;
    root.dataset.zjfReady = '1';
    const cols = [...root.querySelectorAll('[data-zjf-col]')];
    const sync = () => cols.forEach((d) => { if (mq.matches) d.open = true; else if (!d.dataset.touched) d.open = false; });
    cols.forEach((d) => {
      d.querySelector('summary').addEventListener('click', (e) => { if (mq.matches) e.preventDefault(); else d.dataset.touched = '1'; });
    });
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    sync();
    /* after a newsletter sign-up, bring the confirmation into view */
    if (/customer_posted=true/.test(location.search)) {
      const ok = root.querySelector('.zjf__msg--ok, .zjf__msg--err');
      ok && ok.scrollIntoView({ block: 'center' });
    }
  };
  const boot = (scope) => scope.querySelectorAll('[data-zjf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
